<template>
  <HelpContentPage type="1" title-key="FAQ" section-key="helpFaqSection" />
</template>

<script>
import HelpContentPage from '../components/HelpContentPage'

export default {
  name: 'FaqPage',
  components: {HelpContentPage}
}
</script>



// WEBPACK FOOTER //
// src/page/faq2.vue